<!--  -->
<template>
  <div class="nav-box">
    <div
      :class="item.status == 1?'nav-item-abnormal':'nav-item-normal'"
      v-for="(item,i) in basedata"
      :key="i"
      @click="check(i)"
    >{{item.name}}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      basedata: [
        {
          status: 1,
          name: "总览"
        },
        {
          status: 0,
          name: "环境监测"
        },
        {
          status: 0,
          name: "设备设施"
        },
        {
          status: 0,
          name: "罐体监测"
        },
        {
          status: 0,
          name: "安防管理"
        },
        {
          status: 0,
          name: "消防预案"
        }
      ]
    };
  },

  components: {},

  computed: {},

  methods: {
    check(val) {
      this.basedata.forEach((item, i) => {
        if (i == val) {
          item.status = 1;
        } else {
          item.status = 0;
        }
      });
      this.$emit('viewshow',val)
    }
  }
};
</script>
<style lang="less" scoped>

.nav-box {
  position: absolute;
  right: 2.5%;
  top: 16vh;
  color: #fff;
  font-size: 16px;
  font-family: sy;
  z-index: 2000;
   display: block;
  //    background: red;
  .nav-item-normal {
    background: url(../assets/nav-normal.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 170px;
    height: 46px;
    cursor: pointer;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .nav-item-abnormal {
    background: url(../assets/nav-abnormal.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 170px;
    height: 46px;
    cursor: pointer;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
  }
}
</style>